export const GET_MAKEUP_REQUEST= 'GET_MAKEUP_REQUEST';
export const GET_MAKEUP_SUCCESS= 'GET_MAKEUP_SUCCESS';
export const GET_MAKEUP_ERROR= 'GET_MAKEUP_ERROR';


export const GET_SKINCARE_REQUEST= 'GET_SKINCARE_REQUEST';
export const GET_SKINCARE_SUCCESS= 'GET_SKINCARE_SUCCESS';
export const GET_SKINCARE_ERROR= 'GET_SKINCARE_ERROR';